<template>
  <div>
    <div />
  </div>
</template>

<script>
export default {
  name: 'VbLocations',
  components: {},
}
</script>
